import { render, staticRenderFns } from "./ProductCmp.vue?vue&type=template&id=e6efa724&scoped=true"
import script from "./ProductCmp.vue?vue&type=script&lang=js"
export * from "./ProductCmp.vue?vue&type=script&lang=js"
import style0 from "./ProductCmp.vue?vue&type=style&index=0&id=e6efa724&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6efa724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6efa724')) {
      api.createRecord('e6efa724', component.options)
    } else {
      api.reload('e6efa724', component.options)
    }
    module.hot.accept("./ProductCmp.vue?vue&type=template&id=e6efa724&scoped=true", function () {
      api.rerender('e6efa724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/component/EditCmp/ProductCmp.vue"
export default component.exports